export const SERMON_SHOTS_TO_RENDER = 12
export const SERMON_SHOTS_MINIMUM_SIZE = 43 * 1024 // 43kb
